export default __webpack_public_path__ + "01e64e54f04a70287f8b7f0edd03206e.svg";